import type { gqlV2 } from '@vrplatform/data';
import { type Maybe, isUUID } from '@vrplatform/utils';
import type { audit_log } from '@vrplatform/graphql';
import type { ActivityRow } from './_types';

export const ACTIVITY_START_DATE = '2024-05-01';

export const getActivityActor = (log: audit_log): ActivityRow['actor'] => {
  const actorUserId = log.actorUserId;

  const actor = {
    id: log.actorUserId,
    email: log.actorUser?.email || '',
    firstName: log.actorUser?.firstName || '',
    lastName: log.actorUser?.lastName || '',
    avatar: undefined,
  };

  if (actorUserId)
    return {
      ...actor,
      id: actorUserId,
    };

  return null;
};

export const whereActorUserId = (
  actorUserId: Maybe<string>
): gqlV2.InputMaybe<gqlV2.uuid_comparison_exp> | undefined =>
  actorUserId
    ? actorUserId === 'system'
      ? {
          _is_null: true,
        }
      : isUUID(actorUserId)
        ? { _eq: actorUserId }
        : undefined
    : undefined;
